<div class="r-form-group search-container">
    <label class="title">{{'LIDS.SEARCH' |translate}}</label>
    <div class="row" style="align-items:center">
        <input [(ngModel)]="freeSearch" type="text" pInputText size="50" placeholder="{{'LIDS.SEARCH_LID' |translate}}"
            (delayEvent)="filterfreeSearch()" delayEventName="onkeyup">
        <p-button type="button" class="filter-btn" (click)="displaySidebar = true" icon="pi pi-filter"></p-button>
        <app-atn-export-excel [request]="request" [fileName]="'customers'"></app-atn-export-excel>
    </div>
</div>

<p-sidebar [(visible)]="displaySidebar" [baseZIndex]="10000">
    <div class="header">{{'LIDS.TITLE_SIDEBAR' |translate}}</div>

    <div class="filters">
        <div class="r-form-group">
            <label class="title">{{'LIDS.ROULETTE' |translate}}</label>
            <p-dropdown [appendTo]="null" [options]="filteredRoulettes" [(ngModel)]="selectedRoulette"
                optionLabel="label" placeholder="{{'LIDS.ALL_ROULETTES' |translate}}" [showClear]="true"
                (onClear)="selectRoulette()" (onChange)="selectRoulette()"></p-dropdown>
        </div>

        <div class="row">
            <div class="r-form-group date">
                <label class="title" #start>{{'LIDS.START_DATE' |translate}}</label>
                <p-calendar dateFormat="dd/mm/yy" [showButtonBar]="true" inputId="basic" [(ngModel)]="startDate"
                    appendTo="body" [clearButtonStyleClass]="'clear-button'" (onClearClick)="filterCreatedDate()"
                    (onSelect)="filterCreatedDate()">
                </p-calendar>
            </div>
            <div class="r-form-group date">
                <label class="title">{{'LIDS.END_DATE' |translate}}</label>
                <p-calendar dateFormat="dd/mm/yy" [showButtonBar]="true" inputId="basic" [(ngModel)]="endDate"
                    appendTo="body" [clearButtonStyleClass]="'clear-button'" (onClearClick)="filterCreatedDate()"
                    (onSelect)="filterCreatedDate()" (onClickOutside)="filterCreatedDate()"></p-calendar>
            </div>
        </div>
    </div>
</p-sidebar>
<div class="r-form-group totalRecords">{{totalRecords}} {{'ROULETTE.LIDS'|translate}}</div>
<div class="cards-container">

    <app-lid-card-mobile *ngFor="let lid of lids$ | async" (onViewDetails)="onOpenLidDetails($event)" [currentLid]="lid"
        [columns]="columns">
    </app-lid-card-mobile>
</div>
<p-dialog [(visible)]="viewLidDetails" class="dialog" [baseZIndex]="10000" [style]="{width: '608px', height:'720px'}"
    [draggable]="false" [resizable]="false">
    <app-lid-details-dialog *ngIf="viewLidDetails" [lidId]="lidId" [lidDetails]="lidDetails"
        (onCouponImplemented)="loadLids(); viewLidDetails=false"></app-lid-details-dialog>
</p-dialog>
<p class="noData" *ngIf="!returnTotalRecords">{{ 'READONLY_TABLE.NO_DATA_FOUND'|translate }}</p>
<app-paging *ngIf="returnTotalRecords" [totalRecords]="totalRecords" [numRecordsToPage]="numRowsInPage"
    (currentPageChanged)="createRequest($event)"></app-paging>